import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const cv = {
	state: {
		cv: '',
		documentosLigadosAProcesos: ''
	},
	getters: {
		getCvCompleto: state => state.cv,
		getPersonales: state => state.cv.personales,
		getAcademicos: state => state.cv.academicos,
		getnoUniversidad: state => {
			if (state.cv.academicos) {
				return state.cv.academicos.filter(e => !!!e.deLaUniversidad);
			}
		},
		getProfesionales: state => state.cv.profesional,
		getIdiomas: state => state.cv.idiomas,
		getInteres: state => state.cv.interes,
		getProgramasInformaticos: state => {
			if (!!state.cv.interes) {
				return state.cv.interes.programasInformaticos
			}
		},
		getSectoresActividadCV: state => state.cv.sectoresInteres,
		getDocumentos: state => state.cv.documentos,
		getDocumentosPrivados: state => state.cv.documentosPrivados,
		getDocumentosProcesos: state => state.cv.documentosProcesos,
		getDocumentosRequeridosdeProcesos: state => state.documentosLigadosAProcesos,
		getCVDescargable: state => state.cv.urlCV,
		hasPermisoTrabajo: state => state.cv.tienePermisoTrabajo,
		needPermisoTrabajo: state => state.cv.necesitaPermisoTrabajo,
		getImagenPerfil: state => state.cv.urlImagenPerfil,
		getidPeriodoPracticas: state => state.cv.idPeriodoPreferenciaPracticas,
		getbusquedaPracticasActiva: state => state.cv.busquedaPracticasActiva,
		getbusquedaEmpleoActiva: state => state.cv.busquedaTrabajoActiva,
		getPresentacion: state => {
			let presentacion = state.cv.presentacion
			if (state.cv.presentacion != null) {
				presentacion = state.cv.presentacion.replaceAll('\n', '<br/>')
			}
			return presentacion
		},
		getValidado: state => state.cv.validadoDOIP,
		getNivelFormativo: state => state.cv.idNivelFormativoSNE
	},
	actions: {
		requestCV: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Alumno/dameCvUsuario').then(response => {
					(response.data.status == 0) ? commit('setCV', response.data.datos) : commit('setCompleteError', response);
					dispatch('requestDocumentacionDeProcesos');
					resolve(true);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});


		},
		addEstudio: function ({ commit, dispatch }, estudios) {
			return new Promise((resolve, reject) => {


				let estudiosCheck = new Array(estudios.length);

				for (let i in estudios) {

					estudiosCheck[i] = false;

					axios.post('/api/Alumno/addEstudio', estudios[i]).then(response => {

						if (response.data.status == 0) {
							estudiosCheck[i] = true;
							if (!estudiosCheck.some(el => el == false)) {
								resolve(true);
							}
							estudios[i].id = response.data.datos.idNuevaAlta;
							commit('addEstudio', estudios[i]);
							dispatch('requestCV');

						} else {
							commit('setCompleteError', response);
							if (response.data.status == 1) {
								dispatch("sendInfoPeticion", estudios[i]);
							}
							dispatch('sendErrorServer', error.response);
						}

					})
						.catch(function (error) {
							commit('setError', 500);
						});

				}

			});
		},
		addEstudioUniverisidad: function ({ commit, dispatch }, estudios) {
			return new Promise((resolve, reject) => {


				let estudiosCheck = new Array(estudios.length);

				for (let i in estudios) {

					estudiosCheck[i] = false;

					if (String(estudios[i].nota).includes(',')) {
						estudios[i].nota = String(estudios[i].nota).replace(',', '.');
					}

					axios.post('/api/Alumno/addEstudioUniversidad', estudios[i]).then(response => {

						if (response.data.status == 0) {
							estudiosCheck[i] = true;
							if (!estudiosCheck.some(el => el == false)) {
								dispatch('requestCV');
								resolve(true);
							}

						} else {
							commit('setCompleteError', response);
							dispatch('sendErrorServer', error.response);
						}

					})
						.catch(function (error) {
							commit('setError', 500);
						});

				}

			});
		},
		editEstudio: function ({ commit, dispatch }, estudios) {

			return new Promise((resolve, reject) => {

				estudios = estudios.filter(el => !el.deLaUniversidad);

				let estudiosCheck = new Array(estudios.length);

				for (let i in estudios) {

					estudiosCheck[i] = false;

					axios.post('/api/Alumno/editEstudio', estudios[i]).then(response => {

						if (response.data.status == 0) {
							estudiosCheck[i] = true;
							if (!estudiosCheck.some(el => el == false)) {
								resolve(true);
								commit('setEstudios', estudios);
							}
						} else {
							commit('setCompleteError', response);
							if (response.data.status == 1) {
								dispatch("sendInfoPeticion", estudios[i]);
							}
						}

					})
						.catch(function (error) {
							commit('setError', 500);
						});

				}

			});
		},
		delEstudio: function ({ commit, dispatch }, estudio) {
			return new Promise((resolve, reject) => {

				let data = { 'id': estudio };

				axios.post('/api/Alumno/delEstudio', data).then(response => {
					if (response.data.status == 0) {
						commit('eraseEstudio', estudio);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editPersonales: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/editDatosPersonales', data).then(response => {

					if (response.data.status == 0) {

						let user = `${data.nombre} ${data.apellido1} ${data.apellido2}`;
						commit('setNombreUsuarioCambiado', user)

						dispatch('requestCV').then(r => {
							resolve(true);
						});
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}

				})
					.catch(function (error) {
						commit('setError', 500);
					});

			});
		},
		addIdioma: function ({ commit, dispatch }, idiomas) {
			return new Promise((resolve, reject) => {

				let idiomasCheck = new Array(idiomas.length);

				for (let i in idiomas) {

					idiomasCheck[i] = false;

					axios.post('/api/Alumno/addIdioma', idiomas[i]).then(response => {

						if (response.data.status == 0) {
							idiomasCheck[i] = true;
							if (!idiomasCheck.some(el => el == false)) {
								resolve(true);
							}
							idiomas[i].id = response.data.datos.idNuevaAlta;
							commit('addIdioma', idiomas[i]);
							dispatch('requestCV');

						} else {
							commit('setCompleteError', response);
						}

					})
						.catch(function (error) {
							commit('setError', 500);
						});

				}

			});
		},
		editIdiomas: function ({ commit, dispatch }, idiomas) {

			return new Promise((resolve, reject) => {

				let idiomasCheck = new Array(idiomas.length);

				for (let i in idiomas) {

					idiomasCheck[i] = false;

					axios.post('/api/Alumno/editIdioma', idiomas[i]).then(response => {

						if (response.data.status == 0) {
							idiomasCheck[i] = true;
							if (!idiomasCheck.some(el => el == false)) {
								resolve(true);
								commit('setIdiomas', idiomas);
							}
						} else {
							commit('setCompleteError', response);
						}

					})
						.catch(function (error) {
							commit('setError', 500);
						});

				}



			});
		},
		delIdioma: function ({ commit, dispatch }, idioma) {

			let params = { "id": idioma };

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/delIdioma', params).then(response => {
					if (response.data.status == 0) {
						commit('eraseIdioma', idioma);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editIntereses: function ({ commit, dispatch }, intereses) {

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editInteres', intereses).then(response => {
					if (response.data.status == 0) {
						resolve(true)
						commit('setIntereses', intereses);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editSectoresInteres: function ({ commit, dispatch }, intereses) {

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editSectoresInteres', intereses).then(response => {
					if (response.data.status == 0) {
						resolve(true)
						commit('setSectoresInteres', intereses);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editProfesionales: function ({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editProfesionales', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setProfesionales', data);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		addExperiencia: function ({ commit, dispatch }, experiencias) {
			return new Promise((resolve, reject) => {

				let experienciasCheck = new Array(experiencias.length);

				for (let i in experiencias) {

					experienciasCheck[i] = false;

					axios.post('/api/Alumno/addExperiencia', experiencias[i]).then(response => {

						if (response.data.status == 0) {
							experienciasCheck[i] = true;
							if (!experienciasCheck.some(el => el == false)) {
								resolve(true);
							}
							experiencias[i].id = response.data.datos.idNuevaAlta;

							if (!!response.data.datos.enlace) {
								experiencias[i].adjunto = response.data.datos.enlace;
							}

							commit('addExperiencia', experiencias[i]);
							dispatch('requestCV');

						} else {
							commit('setCompleteError', response);
						}

					})
						.catch(function (error) {
							commit('setError', 500);
						});

				}

			});
		},
		addNewExperiencia: function ({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/addExperiencia', data).then(response => {

					if (response.data.status == 0) {
						resolve(true);
						dispatch('requestCV');

					} else {
						commit('setCompleteError', response);
					}

				})
					.catch(function (error) {
						commit('setError', 500);
					});

			});
		},
		editExperiencia: function ({ commit, dispatch }, experiencia) {

			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/editExperiencia', experiencia).then(response => {

					if (response.data.status == 0) {
						resolve(true);
						dispatch('requestCV');
					} else {
						commit('setCompleteError', response);
					}

				})
					.catch(function (error) {
						commit('setError', 500);
					});



			});
		},
		delExperiencia: function ({ commit, dispatch }, idexperiencia) {
			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/delExperiencia', { "id": idexperiencia }).then(response => {
					if (response.data.status == 0) {
						dispatch('requestCV').then(r => {
							if (r) {
								resolve(true);
							}
						});
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		ocultarExperiencia: function ({ commit, dispatch }, idexperiencia) {
			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/bajaEstudioUniversidad', { "id": idexperiencia }).then(response => {
					if (response.data.status == 0) {
						dispatch('requestCV').then(r => {
							if (r) {
								resolve(true);
							}
						});
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		addDoc: function ({ commit, dispatch }, doc, onProgress) {

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/addDoc', doc).then(response => {
					if (response.data.status == 0) {
						dispatch('requestCV')
						resolve(true);
					} else {
						resolve(false);
						commit('setCompleteError', response);
					}

				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		delDoc: function ({ commit, dispatch }, doc) {
			return new Promise((resolve, reject) => {

				let data = { id: doc };

				axios.post('/api/Alumno/delDoc', data).then(response => {
					if (response.data.status == 0) {
						dispatch('requestCV')
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDocumentacionDeProcesos: function ({ commit, dispatch }) {

			axios.get('/api/Alumno/documentacionDeProcesosSolicitada').then(response => {
				if (response.data.status == 0) {
					commit('setDocumentacionProcesos', response.data.datos);
				} else {
					commit('setCompleteError', response);
				}
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		editPermisoTrabajo: function ({ commit, dispatch }, permiso) {
			let data = { permiso: Number(permiso) };
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editPermisoTrabajo', data).then(response => {
					(response.data.status == 0) ? resolve(true) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		setImagenPerfil: function ({ commit, dispatch }, imgdata) {
			let data = {
				"extension": imgdata.extension,
				"ficheroB64": imgdata.img.replace('data:image/png;base64,', '')
			}
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editImagenPerfil', data).then(response => {
					if (response.data.status == 0) {
						dispatch('requestCV');
						resolve(true);
					} else {
						commit('setCompleteError', response);
						resolve(true);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editPortfolio: function ({ commit, dispatch }, url) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editEnlacePortfolio', { "enlace": url }).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setPortfolio', url);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		removePortfolio: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editEnlacePortfolio', { "enlace": null }).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setPortfolio', null);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editEmailParameters: function ({ commit }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editDatosEmail`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setEmailData', data);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editPeriodoPracticas({ commit }, id) {

			let data = { 'idPeriodoPreferencia': Number(id) }

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editDatosPreferenciaPracticas`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setPeriodoPracticas', id);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editDatosBusquedaActivaPracticas({ commit }, status) {

			let data = { "activa": status }

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editDatosBusquedaActivaPracticas`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setbusquedaPracticasActiva', status);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editDatosBusquedaActivaEmpleo({ commit, dispatch }, status) {

			let data = { "activa": status }

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editDatosBusquedaActivaTrabajo`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setbusquedaEmpleoActiva', status);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editCompetencias({ commit }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editCompetencias`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editConocimientosInformaticos({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editConocimientosInformaticos`, data).then(response => {
					if (response.data.status == 0) {
						commit('setConocimientosInformaticos', data);
						resolve(true);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editConocimientosInformaticos({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editConocimientosInformaticos`, data).then(response => {
					if (response.data.status == 0) {
						commit('setConocimientosInformaticos', data);
						resolve(true);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editPresentacion({ commit, dispatch }, data) {

			data = { texto: data };

			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/editPresentacion`, data).then(response => {
					if (response.data.status == 0) {
						commit('setPresentacion', data);
						resolve(true);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editNivelFormativo: function ({ commit, dispatch }, id) {
			let data = { id: Number(id) };
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/editarNivelFormativoSNE', data).then(response => {
					(response.data.status == 0) ? resolve(true) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},

	},
	mutations: {
		setCV: function (state, data) {
			state.cv = data;
		},
		removeCV: function (state) {
			state.cv = '';
		},
		setProfesionales(state, data) {
			state.cv.profesional = data;
		},
		setIntereses(state, data) {
			state.cv.interes = data;
		},
		setSectoresInteres(state, data) {
			state.cv.sectoresInteres = data;
		},
		setConocimientosInformaticos(state, data) {
			state.cv.interes.programasInformaticos = data;
		},
		setIdiomas(state, data) {
			state.cv.idiomas = data;
		},
		setEstudios(state, data) {
			let estudios_uni = state.cv.academicos.filter(el => el.deLaUniversidad);
			state.cv.academicos = estudios_uni.concat(data);
		},
		setExperiencias(state, data) {
			state.cv.profesional.experiencia = data;
		},
		addIdioma(state, data) {
			(!!!state.cv.idiomas) ? state.cv.idiomas = [] : '';
			state.cv.idiomas.push(data);
		},
		addExperiencia(state, data) {
			(!!!state.cv.profesional.experiencia) ? state.cv.profesional.experiencia = [] : '';
			state.cv.profesional.experiencia.push(data);
		},
		addEstudio(state, data) {
			(!!!state.cv.academicos) ? state.cv.academicos = [] : '';
			state.cv.academicos.push(data);
		},
		addDoc(state, doc) {
			(!!!state.cv.documentos) ? state.cv.documentos = [] : '';
			state.cv.documentos.push(doc);
		},
		eraseIdioma(state, idioma) {
			state.cv.idiomas = state.cv.idiomas.filter(el => el.id != idioma);
		},
		eraseDoc(state, id) {
			state.cv.documentos = state.cv.documentos.filter(el => el.id != id);
		},
		eraseExperiencia(state, id) {
			state.cv.profesional.experiencia = state.cv.profesional.experiencia.filter(el => el.id != id);
		},
		eraseEstudio(state, id) {
			state.cv.academicos = state.cv.academicos.filter(el => el.id != id);
		},
		setPortfolio(state, url) {
			state.cv.enlacePortfolio = url;
		},
		setEmailData(state, data) {
			if (!!data.email) {
				state.cv.personales.email = data.email;
			}
			state.cv.personales.comunicacionesEnEmailEstudiante = data.comunicacionesEnEmailEstudiante;
		},
		setPeriodoPracticas(state, id) {
			state.cv.idPeriodoPreferenciaPracticas = id;
		},
		setbusquedaPracticasActiva(state, status) {
			state.cv.busquedaPracticasActiva = status;
		},
		setbusquedaEmpleoActiva(state, status) {
			state.cv.busquedaEmpleoActiva = status;
		},
		setDocumentacionProcesos(state, docs) {
			state.documentosLigadosAProcesos = docs;
		},
		setPresentacion(state, data) {
			state.cv.presentacion = data.texto;
		}
	}
}

export default cv;



// WEBPACK FOOTER //
// ./src/store/cv.js